










































































import {Component, Vue, PropSync, Watch} from 'vue-property-decorator';
import {makeFastFuncOfGetI18n} from '@/utils/i18n';
import RadioElement from '@/components/common/RadioElement.vue';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import CompSelectBox, {CompSelectBoxOption} from '@/components/common/CompSelectBox.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import {DiscountType} from 'supporter';

interface Options<ValueType> {
  name: string;
  hasAll?: boolean;
  noBrackets?: boolean;
  data: {
    id: string;
    dispaly: string; // CheckBoxComponent, RadioElement 에서 dispaly 라고 명시했기 때문에 어쩔 수 없다...
    value: ValueType;
  }[]
}

interface InputError {
  [key: string]: {
    isActive: boolean;
    description: string;
  }
}

@Component({
  components: {
    RadioElement,
    ValidateInput,
    CompSelectBox,
    CheckBoxElement,
  }
})
export default class ChangeInformationAndDiscountSettingForm extends Vue {
  private getI18n = makeFastFuncOfGetI18n('RECURRINGPAYMENTS_PRODUCT');

  @PropSync('deliveryCycles')
  private deliveryCyclesSync!: string;
  @PropSync('isUsedDiscount')
  private isUsedDiscountSync!: boolean;
  @PropSync('discountType')
  private discountTypeSync!: DiscountType;
  @PropSync('discountValue')
  private discountValueSync!: string | null;
  @PropSync('isInvalidDiscountValueFormat')
  private isInvalidDiscountValueFormatSync!: boolean;

  private readonly deliveryCycleOptions: Options<string> = options().DELIVERY_CYCLE_OPTIONS;
  private readonly discountRadioOptions: Options<boolean> = options().DISCOUNT_RADIO_OPTIONS;
  private readonly  discountTypeSelectOptions: CompSelectBoxOption<string>[] = options().DISCOUNT_TYPE_SELECT_OPTIONS
  private inputError: InputError = {
    'AMOUNT': {
      isActive: false,
      description: this.getI18n('ONLY_UNITS_OF_10'),
    },
    'PERCENT': {
      isActive: false,
      description: this.getI18n('ONLY_BETWEEN_0_AND_99'),
    }
  }

  @Watch('discountType')
  @Watch('isUsedDiscountSync')
  private validateDiscountValueFormat(): void {
    if (!this.isUsedDiscountSync) {
      this.isInvalidDiscountValueFormatSync = false;
      return;
    }

    const isNoInput = !this.discountValueSync;
    if (!isNoInput) {
      this.inputError['AMOUNT'].isActive =
          !!(this.discountTypeSync === 'AMOUNT' && Number(this.discountValueSync) % 10);
      this.inputError['PERCENT'].isActive =
          !!(this.discountTypeSync === 'PERCENT' && Number(this.discountValueSync) > 99);
    }

    const isInvalid = isNoInput || Object.values(this.inputError).some(({ isActive }) => isActive);
    this.isInvalidDiscountValueFormatSync = isInvalid;
  }

  private handleDiscountValueInputBlur(): void {
    this.validateDiscountValueFormat();
  }
}

const getI18nOfRecurringPayments: (key: string) => string = makeFastFuncOfGetI18n('RECURRINGPAYMENTS_PRODUCT');
const options = () => ({
  DISCOUNT_RADIO_OPTIONS: Object.freeze({
    name: 'discountRadioOptions',
    data: [
      {
        id: 'useDiscount',
        value: true,
        dispaly: window.$t('COMMON_USE_2') as string,
      },
      {
        id: 'noUseDiscount',
        value: false,
        dispaly: window.$t('COMMON_NOT_USE_2') as string,
      }
    ]
  }) as Options<boolean>,

  DISCOUNT_TYPE_SELECT_OPTIONS: [
    {
      name: window.$t('COMMON_WON') as string,
      value: 'AMOUNT',
    },
    {
      name: '%',
      value: 'PERCENT',
    }
  ] as CompSelectBoxOption<string>[],

  DELIVERY_CYCLE_OPTIONS: {
    name: 'deliveryCycleOptions',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: window.$t('COMMON_ALL_CHECK'),
      },
      {
        id: 'ONE_MONTH',
        value: 'ONE_MONTH',
        dispaly: getI18nOfRecurringPayments('ONE_MONTH'),
      },
      {
        id: 'TWO_MONTH',
        value: 'TWO_MONTH',
        dispaly: getI18nOfRecurringPayments('TWO_MONTH'),
      },
      {
        id: 'THREE_MONTH',
        value: 'THREE_MONTH',
        dispaly: getI18nOfRecurringPayments('THREE_MONTH'),
      },
      {
        id: 'FOUR_MONTH',
        value: 'FOUR_MONTH',
        dispaly: getI18nOfRecurringPayments('FOUR_MONTH'),
      },
      {
        id: 'FIVE_MONTH',
        value: 'FIVE_MONTH',
        dispaly: getI18nOfRecurringPayments('FIVE_MONTH'),
      },
      {
        id: 'SIX_MONTH',
        value: 'SIX_MONTH',
        dispaly: getI18nOfRecurringPayments('SIX_MONTH'),
      },
    ]
  } as Options<string>,
} as const )

